import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { packagesQueryOptions } from '@/core/components/sites/site/rates-and-packages/packages/packagesQueryOptions'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const activitiesSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z
    .enum([
      'title',
      'period',
      'rooms',
      'activities',
      'items',
      'status',
      'orderIndex',
    ])
    .catch('title'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
})

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/'
)({
  validateSearch: (search) => activitiesSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { siteId } }) =>
    queryClient.ensureQueryData(packagesQueryOptions(siteId, auth.token!)),
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
